import React from 'react';
import Hero from '../components/home/Hero';
import TrustSection from '../components/home/TrustSection';
import Services from '../components/home/Services';
import WhyChoose from '../components/home/WhyChoose';
import BeforeAfter from '../components/home/BeforeAfter';
import HowItWorks from '../components/home/HowItWorks';
import ServiceArea from '../components/home/ServiceArea';
import Reviews from '../components/home/Reviews';
import FAQ from '../components/home/FAQ';
import Guarantee from '../components/home/Guarantee';
import QuoteForm from '../components/home/QuoteForm';
import FinalCTA from '../components/home/FinalCTA';
import MobileFloatingCTA from '../components/ui/MobileFloatingCTA';

const Home: React.FC = () => {
  return (
    <main className="relative">
      <Hero />
      <TrustSection />
      <Services />
      <WhyChoose />
      <BeforeAfter />
      <HowItWorks />
      <ServiceArea />
      <Reviews />
      <FAQ />
      <Guarantee />
      <QuoteForm />
      <FinalCTA />
      <MobileFloatingCTA />
    </main>
  );
};

export default Home;
